import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

import styled, { css } from 'styled-components';
import { marginAttributes, paddingAttributes, sizeAttributes, widthAttributes } from '../../system/attributes';
import { getPropsBlocker, makePropList } from '../../utils';
import { gutter } from '../../system/mixins/gutter';
var propertyList = makePropList(['justifyContent', 'direction', 'alignItems', 'alignContent', 'flexGrow', 'flexBasis', 'flexShrink', 'alignSelf', 'isActive', 'flexWrap', 'gutterSpacing']);

var flexRootStyle = function flexRootStyle(_ref) {
  var direction = _ref.direction,
      justifyContent = _ref.justifyContent,
      alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      flexWrap = _ref.flexWrap,
      gutterSpacing = _ref.gutterSpacing;
  var result = {};

  if (direction) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            flex-direction: ", ";\n        "])), result, direction);
  }

  if (justifyContent) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            justify-content: ", ";\n        "])), result, justifyContent);
  }

  if (alignContent) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            align-content: ", ";\n        "])), result, alignContent);
  }

  if (flexWrap) {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            flex-wrap: ", ";\n        "])), result, flexWrap);
  }

  if (alignItems) {
    result = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ", ";\n            align-items: ", ";\n        "])), result, alignItems);
  }

  if (gutterSpacing) {
    result = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            ", ";\n            && {\n                ", ";\n            }\n        "])), result, gutter({
      spacing: gutterSpacing
    }));
  }

  return result;
};

var flexItemStyle = function flexItemStyle(_ref2) {
  var flexGrow = _ref2.flexGrow,
      flexShrink = _ref2.flexShrink,
      flexBasis = _ref2.flexBasis,
      order = _ref2.order,
      alignSelf = _ref2.alignSelf;
  var result = {};

  if (typeof flexGrow !== 'undefined') {
    result = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            ", ";\n            flex-grow: ", ";\n        "])), result, flexGrow);
  }

  if (typeof flexShrink !== 'undefined') {
    result = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            ", ";\n            flex-shrink: ", ";\n        "])), result, flexShrink);
  }

  if (typeof flexBasis !== 'undefined') {
    result = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            ", ";\n            flex-basis: ", ";\n        "])), result, flexBasis);
  }

  if (typeof order !== 'undefined') {
    result = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            ", ";\n            order: ", ";\n        "])), result, order);
  }

  if (alignSelf) {
    result = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: ", ";\n        "])), result, alignSelf);
  }

  return result;
};

export var FlexRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    display: flex;\n\n    ", "\n    ", "\n    ", "\n"])), flexRootStyle, sizeAttributes, marginAttributes);
export var FlexItemRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n"])), flexItemStyle, paddingAttributes, widthAttributes);